import { gql, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router';
import { UsersQuery } from '../../queries';
import FormContainer from '../FormContainer';
import UserForm from './UserForm';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';

const InviteUserMutation = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      result {
        id
        email
      }
      errors
    }
  }
`;

const INITIAL_FORM_VALUES = {
  email: '',
};

const InviteUser = () => {
  const navigate = useNavigate();

  const [mutation] = useMutation(InviteUserMutation, {
    refetchQueries: [{ query: UsersQuery }],
    onCompleted: (response) => {
      const responseObject = Object.values(response)[0];
      if (responseObject.errors) {
        console.error(responseObject.errors);
      } else {
        navigate(`/superadmin/users/${responseObject.result.id}/edit`);
      }
    },
    onError: (e) => console.error(e),
  });

  useSetBreadcrumbEffect([{ display: 'New' }], []);

  return (
    <FormContainer>
      <h2>Invite a new user</h2>
      <UserForm
        mutation={mutation}
        initialValues={INITIAL_FORM_VALUES}
        submitButtonText="Invite User"
        successMessage="User invited successfully"
      />
    </FormContainer>
  );
};

export default InviteUser;
